var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconawesomeCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.625,
    height: 31.625,
    viewBox: "0 0 31.625 31.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-checkmark-circle-outline",
    "data-name": "Icon ionic-ios-checkmark-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_754",
    "data-name": "Trazado 754",
    d: "M26.718,13.673,25.38,12.3a.288.288,0,0,0-.213-.091h0a.276.276,0,0,0-.213.091L15.68,21.641,12.3,18.265a.294.294,0,0,0-.426,0l-1.353,1.353a.3.3,0,0,0,0,.433l4.257,4.257a1.346,1.346,0,0,0,.889.433,1.411,1.411,0,0,0,.882-.418h.008L26.726,14.107A.325.325,0,0,0,26.718,13.673Z",
    transform: "translate(0.573 0.717)",
    fill: "#b2a169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_755",
    "data-name": "Trazado 755",
    d: "M19.188,5.5A13.679,13.679,0,1,1,9.51,9.51,13.593,13.593,0,0,1,19.188,5.5m0-2.129A15.812,15.812,0,1,0,35,19.188,15.81,15.81,0,0,0,19.188,3.375Z",
    transform: "translate(0 0)",
    fill: "#b2a169"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeCheckCircle);
export default __webpack_public_path__ + "static/media/Icon awesome-check-circle.e7e4e4758fa700be2523358fbbbb2c3c.svg";
export { ForwardRef as ReactComponent };